"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VirtualizedTreeList = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var react_window_1 = require("react-window");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var forward_ref_with_statics_1 = require("../_util/forward-ref-with-statics");
var merge_refs_1 = require("../_util/merge-refs");
var TreeNode_1 = require("./TreeNode");
var TreeContext_1 = require("./TreeContext");
var config_context_1 = require("../_util/config-context");
var defaultItemHeight = 32;
function Row(_a) {
    var _b;
    var data = _a.data, index = _a.index, style = _a.style;
    var classPrefix = config_context_1.useConfig().classPrefix;
    var _c = react_1.useContext(TreeContext_1.TreeContext), activable = _c.activable, activeIds = _c.activeIds;
    var _d = data[index], pure = _d.pure, _e = _d.style, nodeStyle = _e === void 0 ? {} : _e, className = _d.className, props = tslib_1.__rest(_d, ["pure", "style", "className"]);
    return (react_1.default.createElement("li", { className: classnames_1.default(classPrefix + "-tree__node", className, (_b = {
                // 高亮
                // eslint-disable-next-line react/destructuring-assignment
                "is-selected": activable && activeIds.includes(props.id)
            },
            _b[classPrefix + "-tree__node--transparent"] = pure,
            _b)), style: tslib_1.__assign(tslib_1.__assign({}, style), nodeStyle) },
        react_1.default.createElement(TreeNode_1.TreeNode, tslib_1.__assign({}, props))));
}
exports.VirtualizedTreeList = forward_ref_with_statics_1.forwardRefWithStatics(function VirtualizedList(_a, ref) {
    var nodes = _a.nodes, listHeight = _a.height, onScrollBottom = _a.onScrollBottom, virtualizedRef = _a.virtualizedRef;
    var vRef = react_1.useRef(null);
    var listRef = react_1.useRef(null);
    // VariableSizeList 默认按 index 缓存 style，需手动触发重置
    react_1.useEffect(function () {
        if (vRef.current) {
            nodes.forEach(function (_, i) { return vRef.current.resetAfterIndex(i, true); });
        }
    }, [nodes]);
    var _b = tslib_1.__read(Array.isArray(listHeight)
        ? listHeight
        : [listHeight, listHeight], 2), minHeight = _b[0], maxHeight = _b[1];
    var itemsSize = react_1.useMemo(function () {
        return nodes.reduce(function (p, _, i) { return p + (nodes[i].height || defaultItemHeight); }, 0);
    }, [nodes]);
    var height = react_1.useMemo(function () {
        if (typeof minHeight === "number" && minHeight > itemsSize) {
            return minHeight;
        }
        if (typeof maxHeight === "number" && maxHeight < itemsSize) {
            return maxHeight;
        }
        if (typeof minHeight === "number" &&
            typeof maxHeight === "number" &&
            minHeight < itemsSize &&
            maxHeight > itemsSize) {
            return itemsSize;
        }
        return maxHeight !== null && maxHeight !== void 0 ? maxHeight : itemsSize;
    }, [itemsSize, maxHeight, minHeight]);
    function handleScroll(props) {
        if (listRef.current && onScrollBottom) {
            if (typeof maxHeight !== "number" || itemsSize > maxHeight) {
                var _a = listRef.current, scrollHeight = _a.scrollHeight, scrollTop = _a.scrollTop, clientHeight = _a.clientHeight;
                if (scrollHeight <= Math.ceil(clientHeight + scrollTop + 1)) {
                    onScrollBottom(props);
                }
            }
        }
    }
    return (react_1.default.createElement(react_window_1.VariableSizeList, { ref: merge_refs_1.mergeRefs(virtualizedRef, vRef), innerRef: ref, outerRef: listRef, height: height, width: "100%", itemCount: nodes.length, itemSize: function (index) {
            return nodes[index].height || defaultItemHeight;
        }, innerElementType: "ul", onScroll: handleScroll, itemKey: function (index) { return nodes[index].pathKey || nodes[index].id; }, itemData: nodes }, Row));
}, {
    displayName: "VirtualizedList",
});
//# sourceMappingURL=VirtualizedTreeList.js.map